import * as React from 'react';
import { sanitizeHtml } from '@shared/lib';
import type { Config } from 'dompurify';

type SafeHtmlTag = Extract<keyof JSX.IntrinsicElements, keyof HTMLElementTagNameMap>;

type Props = {
	html: string;
	tag?: SafeHtmlTag;
	className?: string;
	sanitizeConfig?: Config;
} & Omit<React.HTMLAttributes<HTMLElement>, 'dangerouslySetInnerHTML'>;

const SafeHtml = React.forwardRef<HTMLElement, Props>(
	({ html, tag = 'div', className, sanitizeConfig, ...rest }, ref) => {
		const clean = React.useMemo(() => sanitizeHtml(html, sanitizeConfig), [html, sanitizeConfig]);

		return React.createElement(tag, {
			'data-sanitized-html': true,
			...rest,
			ref,
			className,
			dangerouslySetInnerHTML: { __html: clean }
		});
	}
);

SafeHtml.displayName = 'SafeHtml';

export default SafeHtml;
